import { render } from "./BookInfo.vue?vue&type=template&id=0fe1cef8&scoped=true"
import script from "./BookInfo.vue?vue&type=script&lang=js"
export * from "./BookInfo.vue?vue&type=script&lang=js"

import "./BookInfo.vue?vue&type=style&index=0&id=0fe1cef8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe1cef8"]])

export default __exports__